import { render } from 'base/wrapped-render';
import { EmployeeTypeSelectionModal } from './employee-type-selection-modal';

/**
 * Renders the EmployeeTypeSelectionModal component if the EOR Remote Onboarding Integration feature flag is enabled.
 * The modal is rendered in a container element with the id 'employee-type-selection-modal-container', appended to the document body.
 */
export const openEmployeeTypeSelectionModal = () => {
    const modalContainer = document.createElement('div');
    modalContainer.id = 'employee-type-selection-modal-container';
    document.body.appendChild(modalContainer);

    const onCloseModal = () => {
        render(<EmployeeTypeSelectionModal isOpen={false} onClose={onCloseModal} />, modalContainer);
    };

    render(<EmployeeTypeSelectionModal isOpen={true} onClose={onCloseModal} />, modalContainer);
};
